// Bornes des taux saisis pour que le prix de vente reste positif et fini (les taux négatifs sont autorisés)
// - Taux de marge (1)  : PV = PR × (1 + m / 100)   → m > -100
// - Taux de marque (2) : PV = PR × 100 / (100 - m) → m < 100

export function marginBounds(marginType) {
    return marginType == 2 ? { min: null, max: 99.99 } : { min: -99.99, max: null };
}

export function isMarginInBounds(marginType, margin) {
    return marginType == 2 ? parseFloat(margin) < 100 : parseFloat(margin) > -100;
}
